var _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_radial_9549_62077)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint1_radial_9549_62077)",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint2_radial_9549_62077)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint3_linear_9549_62077)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9549_62077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.875 11.025) rotate(63.0723) scale(15.8988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324452,
    stopColor: "#FEF2E9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF2E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9549_62077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 9) rotate(139.97) scale(16.3248 16.4588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCDA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCDA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9549_62077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3 1.05) rotate(47.84) scale(20.3366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF2E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9549_62077",
    x1: -5.72727,
    y1: 38.7273,
    x2: 6.27273,
    y2: 16.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62B5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62B5E5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble3);
export default __webpack_public_path__ + "static/media/bubble3.638b2a4a860470322708a20a2250557b.svg";
export { ForwardRef as ReactComponent };